/**
 * @author: Ahmad Samoudi - Bluetd <a.samoudi@blue.ps>
 */

/*
    IMPORTANT (MUST READ)
    - This plugin requires jquery
    - AND requires jquery-confirm plugin to be loaded first if you are enabling the option --showConfirmOnSuccess--

    - YOU HAVE TO handle window.filesUploading if you are having files that must be uploaded before sending the form
 */

/*
    OPTIONS
    -- Option showErrorGeneralMsg is for always displaying the general error message sent by the exception thrown
        the plugin shows the general error message by default only if the request has no errors for its fields
    -- Option requiredMsg Can be displayed if and only if checkRequired is enabled
    -- Option scrollMargin will be taken into consideration if and only if scrollToFirstError is enabled

    Plugin options have default values, if you want to set a certain option, you can send it when initializing
    DO NOT EDIT OPTIONS VALUES FROM HERE
 */

/*
    CallBacks
    -- You can add some of your customizations by using the plugin's CallBacks in the options
 */

/*
    Css
    -- A default styles can be found in the css file beside the js file, you can update or remove them as needed
       It shows all possible css classes that can be shown by this plugin
       && It shows how to manipulate the loader and other such issues
 */

/*
    HAPPY CODING :)
 */

$.fn.validateForm = function (options) {

    let _options = $.extend(
        {
            browserValidation: false,
            successPopUpTitle: 'Confirmation',
            okPopUpBtnText: 'Ok',
            showErrorGeneralMsg: false,
            checkRequired: false,
            requiredMsg: 'This field is required',
            scrollToFirstError: false,
            scrollMargin: 0,
            emptyFieldsOnSuccess: true,
            showConfirmOnSuccess: false,
            emailValidationMsg: 'Please enter a valid email',
            filesUploadingMsg: 'Please wait until your files are fully uploaded!',
            requestHeaders: {},
            // CallBacks
            onInitCallBack: null,
            beforeAjaxCallBack: null,
            beforeSendStartsCallBack: null,
            beforeSendEndsCallBack: null,
            beforeSuccessStartsCallBack: null,
            beforeSuccessEndsCallBack: null,
            beforeErrorStartsCallBack: null,
            beforeErrorEndsCallBack: null,
            beforeCompleteStartsCallBack: null,
            beforeCompleteEndsCallBack: null,
        }
        , options);

    let _formsArray = [];
    $(this).each((index, form) => {
        _formsArray.push($(form));
    });

    $.each(_formsArray, (index, _form) => {
        _form.find('button[type="submit"]').attr('disabled', false);
        if (!_options.browserValidation) {
            _form.attr('novalidate', true);
        }

        if (typeof _options.onInitCallBack === 'function') {
            _options.onInitCallBack.call(this, _form);
        }

        _submitForm(_form, _options);
    });
};

const _submitForm = (_form, _options) => {
    let _isSending = false;
    let _allowToSend = true;

    _form.submit(function (e) {
        e.preventDefault();
        CKEditorUpdate();

        _form.find('.form-msg').remove();
        _form.find('.input-control-error').remove();
        _form.find('.input-control.has-error').removeClass('has-error');

        _allowToSend = true;
        let _fError;

        if (_options.checkRequired) {
            _allowToSend = _checkRequiredFields(_form, _options);
        }

        _form.find('input[type="email"]').each(function () {
            if ($(this).val().length > 0 && !validateEmail($(this))) {
                _addErrorMsg($(this), _options.emailValidationMsg);
                _allowToSend = false;
            }
        });

        if (typeof _options.beforeAjaxCallBack === 'function') {
            _options.beforeAjaxCallBack.call(this, _form);
        }

        if (window.filesUploading) {
            _form.prepend('<div class="form-msg is-error">' + _options.filesUploadingMsg + '</div>');
        }

        if (_options.scrollToFirstError) {
            _fError = _form.find('.form-msg');
            if (_fError.length) {
                _scrollToError(_fError, _options.scrollMargin);
            } else {
                _fError = _form.find('.input-control-error').first().closest('.input-control');
                if (_fError.length) {
                    _scrollToError(_fError, _options.scrollMargin);
                }
            }
        }

        if (typeof _options.beforeAjaxCallBack === 'function') {
            _options.beforeAjaxCallBack.call(this, _form);
        }

        if (_allowToSend && !_isSending && !window.filesUploading) {
            let _headers = _options.requestHeaders;
            if (typeof application.requestToken !== 'undefined') {
                if (typeof application.requestToken.key !== 'undefined' && typeof application.requestToken.value !== 'undefined') {
                    _headers['Token-Key'] = application.requestToken.key;
                    _headers['Token-Value'] = application.requestToken.value;
                }
            }

            $.ajax({
                url: _form.attr('action'),
                data: _form.serialize(),
                method: "post",
                dataType: 'json',
                headers: _headers,
                beforeSend: function () {
                    if (typeof _options.beforeSendStartsCallBack === 'function') {
                        _options.beforeSendStartsCallBack.call(this, _form);
                    }

                    _isSending = true;
                    _form.addClass('form-is-sending');

                    if (typeof _options.beforeSendEndsCallBack === 'function') {
                        _options.beforeSendEndsCallBack.call(this, _form);
                    }
                },
                success: function (response) {
                    if (typeof _options.beforeSuccessStartsCallBack === 'function') {
                        _options.beforeSuccessStartsCallBack.call(this, _form, response);
                    }

                    if (_options.emptyFieldsOnSuccess) {
                        _form.find('input, select, textarea').not('[type="hidden"]').val('');
                        _form.find('input[type="checkbox"], input[type="radio"]').each(function () {
                            $(this).prop('checked', false);
                        });
                        _form.find('.media--uploads-list').empty();
                        _form.find('.lego-files-preview').remove();
                    }
                    if (typeof response.redirect !== 'undefined' && response.redirect.length > 0) {
                        window.open(response.redirect, '_self');
                    } else {
                        if (_options.showConfirmOnSuccess) {
                            $.confirm({
                                title: _options.successPopUpTitle,
                                content: response.message,
                                containerFluid: true,
                                bootstrapClasses: {
                                    row: 'row justify-content-center',
                                },
                                type: 'green',
                                buttons: {
                                    ok: {
                                        text: _options.okPopUpBtnText,
                                        btnClass: 'btn-success',
                                        keys: ['enter'],
                                        action: function () {
                                            return true;
                                        }
                                    }
                                }
                            });
                        } else {
                            if (typeof response.message !== 'undefined' && response.message.length > 0) {
                                _form.prepend('<div class="form-msg is-success">' + response.message + '</div>');
                            }
                        }
                    }

                    _form.removeClass('form-is-sending');
                    _isSending = false;

                    if (typeof _options.beforeSuccessEndsCallBack === 'function') {
                        _options.beforeSuccessEndsCallBack.call(this, _form, response);
                    }
                },
                error: function (response) {
                    if (typeof _options.beforeErrorStartsCallBack === 'function') {
                        _options.beforeErrorStartsCallBack.call(this, _form, response);
                    }

                    let _response = response.responseJSON;
                    if (_options.showErrorGeneralMsg && typeof _response.message !== 'undefined') {
                        _form.prepend('<div class="form-msg is-error">' + _response.message + '</div>');
                    }
                    if (typeof _response !== 'undefined') {
                        _handleErrors(_form, _options, _response);
                    }
                    if (_options.scrollToFirstError) {
                        _fError = _form.find('.form-msg');
                        if (_fError.length) {
                            _scrollToError(_fError, _options.scrollMargin);
                        } else {
                            _fError = _form.find('.input-control-error').first().closest('.input-control');
                            if (_fError.length) {
                                _scrollToError(_fError, _options.scrollMargin);
                            }
                        }
                    }

                    _form.removeClass('form-is-sending');
                    _isSending = false;

                    if (typeof _options.beforeErrorEndsCallBack === 'function') {
                        _options.beforeErrorEndsCallBack.call(this, _form, response);
                    }
                },
                complete: function () {
                    if (typeof _options.beforeCompleteStartsCallBack === 'function') {
                        _options.beforeCompleteStartsCallBack.call(this, _form, response);
                    }

                    _form.removeClass('form-is-sending');
                    _isSending = false;

                    let _captcha = _form.find('.g-recaptcha');
                    if (_captcha.length && typeof window.grecaptcha !== 'undefined') {
                        let _id = _captcha.attr('data-id');
                        if (_id) {
                            window.grecaptcha.reset(_id);
                        }
                    }

                    if (typeof _options.beforeCompleteEndsCallBack === 'function') {
                        _options.beforeCompleteEndsCallBack.call(this, _form, response);
                    }
                }
            });
        }
    });
};

const _checkRequiredFields = (_form, _options) => {

    const translate = (element, message) => {
        return message.replace(/%field%/g, element.find('.field_style1').first().attr('placeholder'));
    }

    let _allowToSend = true;
    _form.find('.required').each(function () {
        let _field = $(this);
        if (_field.find('.matrix-control').length) {
            let _mBody = _field.find('.matrix-body');
            if (!_mBody.length) {
                _mBody = _field.find('tbody');
            }
            let _rows = _mBody.find('.matrix-row').not('.template');
            if (_rows.length === 0) {
                _allowToSend = false;
                _addErrorMsg(_field, translate(_field, _options.requiredMsg), false);
            }
        } else if (_field.find('.media--uploads-list').length) {
            let _uploads = _field.find('.media--uploads-list');
            if (_uploads.length) {
                _uploads.each(function () {
                    if ($(this).html().length === 0) {
                        _allowToSend = false;
                        _addErrorMsg(_field, translate(_field, _options.requiredMsg), false);
                    }
                });
            }
        } else if (_field.find('.lego-browse-wrapper').length) {
            let _uploads = _field.find('.lego-files-preview');
            if (!_uploads.length) {
                _allowToSend = false;
                _addErrorMsg(_field, translate(_field, _options.requiredMsg), false);
            }
        } else {
            $(this).find('input:not([type="hidden"]), select, textarea').each(function () {
                let _isEmpty = false;
                if (typeof $(this).attr('type') !== 'undefined' && ($(this).attr('type') === 'radio' || $(this).attr('type') === 'checkbox')) {
                    let _inputName = $(this).attr('name');
                    let _input = _form.find('[name="' + _inputName + '"]');
                    if (!_input.is(':checked')) {
                        _isEmpty = true;
                    }
                } else {
                    let _val = $(this).val();
                    _val = $.trim(_val);
                    if (_val.length === 0) {
                        _isEmpty = true;
                    }
                }
                if (_isEmpty) {
                    _allowToSend = false;
                    _addErrorMsg(_field, translate(_field, _options.requiredMsg), false);
                }
            });
        }
    });
    return _allowToSend;
};

const _addErrorMsg = (_element, _msg, _isField = true) => {
    if (_isField) {
        let _wrapper = _element.closest('.input-control');
        _wrapper.addClass('has-error');
        let _errorWrapper = _wrapper.find('.input-control-error');
        if (_errorWrapper.length === 0) {
            _wrapper.append('<div class="input-control-error"></div>');
        }
        _wrapper.find('.input-control-error').append('<p>' + _msg + '</p>');
    } else {
        _element.addClass('has-error');
        let _errorWrapper = _element.find('.input-control-error');
        if (_errorWrapper.length === 0) {
            _element.append('<div class="input-control-error"></div>');
        }
        _element.find('.input-control-error').append('<p>' + _msg + '</p>');
    }
};

const _scrollToError = (_element, _margin) => {
    $('html, body').animate({
        scrollTop: _element.offset().top - _margin
    }, 250);
};

const validateEmail = (_field) => {
    let _email = _field.val();
    let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(_email);
};

const _handleErrors = (_form, _options, _response) => {
    let _errors = _response.errors;
    let _errorsArray = [];
    $.each(_errors, function (_element, _msg) {
        if (_element.length !== 0) {
            _errorsArray.push(_msg);
        }
    });
    if (_errorsArray.length === 0 && typeof _response.message !== 'undefined' && _response.message.length !== 0) {
        _form.prepend('<div class="form-msg is-error">' + _response.message + '</div>');
    } else {
        $.each(_errors, function (_element, _msg) {
            let _field;
            let _inputControl;
            if (_element === 'recaptcha') {
                _field = _form.find('.g-recaptcha');
            } else {
                _field = _form.find('[name="' + _element + '"]');
            }
            if (_field.length === 0) {
                _field = _form.find('[data-field-code="' + _element + '"]');
            }
            if (_field.length === 0) {
                _field = _form.find('[data-name="' + _element + '"]');
            }
            if (_field.length === 0) {
                _field = _form.find('[data-matrix-code="' + _element + '"]');
            }
            if ($.isArray(_msg)) {
                $.each(_msg, function (_index, _iMsg) {
                    _addErrorMsg(_field, _iMsg);
                });
            } else {
                _addErrorMsg(_field, _msg);
            }
        });
    }
};

function CKEditorUpdate() {
    if (typeof CKEDITOR !== 'undefined') {
        if (typeof CKEDITOR.instances !== 'undefined') {
            $.each(CKEDITOR.instances, function (index, instance) {
                if (typeof instance !== 'undefined') {
                    instance.updateElement();
                }
            });
        }
    }
}